import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbNotAllowed: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 24, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill='transparent' {...props}>
        <g id='Box'>
          <rect width='24' height='24' />
        </g>
        <g id='Drive' fill={fill}>
          <path d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1ZM3,12A9,9,0,0,1,5,6.39L17.59,19A9,9,0,0,1,3,12Zm16,5.61L6.37,5A9,9,0,0,1,19,17.62Z' />
        </g>
      </svg>
    </>
  );
};
